import React from 'react';
import { useSelector } from 'react-redux';

// images
import LogoEN from '../../../images/static/logo_en.svg';
import LogoES from '../../../images/static/logo_es.svg';

// import components
import LocalisationButton from 'js/components/localisation/Localisation.button';

const HeaderHome = () => {
  const locale = useSelector((state) => state.app.locale);

  return (
    <header className="header--home">
      <div className="header--home__logo">
        <img src={locale === 'en' ? LogoEN : LogoES} alt="SOLH Logo" />
      </div>
      <LocalisationButton />
    </header>
  );
};

export default HeaderHome;
